export default __webpack_public_path__ + "static/screens-bottom-mobile-ac0e54101e6ed77554b0a1f5f591974d.jpg";